import { List, ListItem, ListItemText } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useObserver } from 'mobx-react-lite';
import React, { useContext } from 'react';
import UserContext from '../auth/UserContext';
import Gravatar from '../common/Gravatar';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuHeader: {
      padding: 16
    },
    gravatar: {
      width: 32,
      height: 32
    }
  })
);

function AccountMenu(props: RouteComponentProps) {
  const classes = useStyles({});
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const user = useContext(UserContext);

  function onMenuOpen(event: React.MouseEvent<HTMLButtonElement>) {
    setMenuAnchorEl(event.currentTarget);
  }

  function onMenuClose() {
    setMenuAnchorEl(null);
  }

  function onShowPreferences() {
    onMenuClose();
    props.history.push('/preferences');
  }

  function onShowApiDocs() {
    onMenuClose();
    props.history.push('/api-docs');
  }

  return useObserver(() => (
    <div>
      {!user && <Button color="inherit">Login</Button>}
      {user && <IconButton onClick={onMenuOpen}><Gravatar email={user.email} className={classes.gravatar} /></IconButton>}
      <Popover
        id="account-menu"
        open={Boolean(menuAnchorEl)}
        anchorEl={menuAnchorEl}
        onClose={onMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div>
          <div className={classes.menuHeader}>
            <Typography>{user.email}</Typography>
          </div>
          <Divider />
          <List dense>
            <ListItem button onClick={onShowPreferences}>
              <ListItemText primary="Preferences" />
            </ListItem>
            <ListItem button onClick={onShowApiDocs}>
              <ListItemText primary="API Documentation" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Sign Out" />
            </ListItem>
          </List>
        </div>
      </Popover>
    </div>
  ));
};

export default withRouter(AccountMenu);
